// @ts-nocheck 4871da84
import * as preview from '../preview/preview';

const { isPreviewReady } = preview.selectors;

const isPopUpMode = (state, dsRead) =>
  Boolean(isPreviewReady(state) && dsRead.pages.popupPages.getCurrentPopupId());

export { isPopUpMode };
